var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const DEFAULT_WATCH_OPTIONS = {
    shortPollingInterval: 3000,
    longPollingInterval: 10000,
    enableBackgroundPolling: true,
};
/**
 * Creates a composable that watches a resource by polling the server continuously.
 * By default, the polling interval is 'short' when the app is active (in the current tab) and 'long'
 * when the app is in the background (not in the current tab).
 * You can also completely disable background polling by setting `enableBackgroundPolling` to false in the options.
 * @param watchHandler The handler function that watches the resource by querying the server.
 * @param options Options to customize the polling interval.
 */
export function useResourceWatcher(watchHandler, options = DEFAULT_WATCH_OPTIONS) {
    const { shortPollingInterval, longPollingInterval, enableBackgroundPolling } = Object.assign(Object.assign({}, DEFAULT_WATCH_OPTIONS), options);
    let currentPollingInterval = shortPollingInterval;
    let watchTimeout = null;
    let isEventSetup = false;
    /**
     * Starts watching the resource by polling the server continuously.
     */
    function startWatchingResource() {
        stopWatchingResource();
        tryWatchResource();
    }
    /**
     * Stops continuously watching the resource.
     */
    function stopWatchingResource() {
        if (watchTimeout) {
            clearTimeout(watchTimeout);
            watchTimeout = null;
        }
    }
    function tryWatchResource() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield watchHandler();
            }
            catch (error) {
                console.warn(error);
            }
            finally {
                if (currentPollingInterval) {
                    watchTimeout = setTimeout(() => {
                        tryWatchResource();
                    }, currentPollingInterval);
                }
            }
        });
    }
    function setupVisibilityListeners() {
        if (!isEventSetup) {
            isEventSetup = true;
            document.addEventListener("visibilitychange", updateThrottle);
        }
    }
    function updateThrottle() {
        if (document.visibilityState === "visible") {
            currentPollingInterval = shortPollingInterval;
            startWatchingResource();
        }
        else {
            currentPollingInterval = enableBackgroundPolling ? longPollingInterval : undefined;
        }
    }
    setupVisibilityListeners();
    return {
        startWatchingResource,
    };
}
